/**
 * @desc: 人工复核
 * @created: 2020/4/30
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/manualReview'

export default {
  namespaced: true,
  actions: {
    // 法院公告检索
    async getAnalysisAffichIndex(ctx, payload) {
      const res = await Models.getAnalysisAffichIndex(payload);

      if (res && res.status === 200 && res.data) {
        return res.data.map(elem => {
          elem.details = null;
          return elem;
        });
      } else {
        return [];
      }
    },

    // 法院公告详情
    async getAnalysisAffichDetail(ctx, payload) {
      const res = await Models.getAnalysisAffichDetail(payload);
      return (res && res.status === 200 && res.data) || [];
    },

    // 判决文书检索列表
    async getAnalysisJudgmentIndex(ctx, payload) {
      const res = await Models.getAnalysisJudgmentIndex(payload);

      if (res && res.status === 200 && res.data) {
        return res.data.map(elem => {
          elem.details = null;
          return elem;
        });
      } else {
        return [];
      }
    },

    // 获取判决文书详情
    async getAnalysisJudgmentDetail(ctx, payload) {
      const res = await Models.getAnalysisJudgmentDetail(payload);
      return (res && res.status === 200 && res.data) || []
    },

    // 判决文书列表详细
    async getAnalysisJudgmentIndexDetail(ctx, payload) {
      const res = await Models.getAnalysisJudgmentIndexDetail(payload);
      return (res && res.status === 200 && res.data) || []
    },

    // 获取失信被执行人列表 (简略)
    async getDisPersonIndex(ctx, payload) {
      const res = await Models.getDisPersonIndex(payload)
      if (res && res.status === 200 && res.data) {
        return res.data.map(elem => {
          elem.details = null
          return elem
        });
      } else {
        return []
      }
    },

    // 获取失信被执行人详细
    async getDisPersonDetail(ctx, payload) {
      const res = await Models.getDisPersonDetail(payload)
      return res && res.status === 200 ? res.data || {} : {}
    }
  }
}
